import Vue from 'vue';
import Vuex from 'vuex';

import auth from '../vuex/auth';
import app from '../vuex/app';
import profile from '../vuex/profile';
import user from '../vuex/user';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    app,
    profile,
    user
  }
});
